import { Title } from '@components/v2/ui/Title';
import { useOffsetProjectAdditional } from '@features/offsets/hooks/useOffsetProjectAdditional';
import { TAdditionalProject } from '@features/offsets/types';
import { Box } from '@mantine/core';
import useStore from '@store/index';
import { useTranslation } from 'react-i18next';
import { WarningAlert } from '../WarningAlert/WarningAlert';
import { AdditionalitiesOffsetCard } from './AdditionalitiesOffsetCard';
import { AdditionalitiesOffsetSummary } from './AdditionalitiesOffsetSummary';
import classes from './AdditionalitiesOffsetSummaryCart.module.css';

const AdditionalitiesOffsetSummaryCart = ({
	items,
	total,
	onRemove,
}: {
	items: any[];
	total: any;
	onRemove: (item: TAdditionalProject) => void;
}) => {
	const { t } = useTranslation();

	const {
		handleProjectFilter,
		handleCountryFilter,
		handleTechnologyFilter,
		isSelectedProjectAdditional,
		handleRemoveSelectedProject,
		handleNextStep,
		handleAddProject,
		handleOnChangePrice,
		handleActiveFilter,
	} = useOffsetProjectAdditional();

	// Fonction utilitaire pour convertir en nombre sûr
	const safeNumber = (
		value: number | string | undefined | null
	) => {
		const num = Number(value);
		return isNaN(num) ? 0 : num;
	};

	const {
		offsetAdditionalProjectsSelected,
		offsetProducedAddis,
	} = useStore();

	const totalPriceSelected =
		offsetAdditionalProjectsSelected.reduce(
			(sum, item) => sum + item.price,
			0
		);

	const isOverrangePrice =
		offsetProducedAddis < totalPriceSelected;

	const isMaxSelectedProjects =
		Array.isArray(offsetAdditionalProjectsSelected) &&
		offsetAdditionalProjectsSelected.length >= 4;

	return (
		<Box className={classes.container}>
			<Title order={6} c={'#1D3965'}>
				{t('global.detailOfAllocations')}
			</Title>
			{items.map((item) => (
				<AdditionalitiesOffsetCard
					onPriceChange={(newPrice: number) => {
						handleOnChangePrice(item, newPrice);
					}}
					onRemove={() => {
						onRemove(item);
					}}
					name={item.name}
					price={safeNumber(item.price)}
				/>
			))}

			<AdditionalitiesOffsetSummary total={total} />

			{isOverrangePrice && (
				<WarningAlert
					description={t('offsets.textOverMaxPrice')}
				/>
			)}
			{isMaxSelectedProjects && (
				<WarningAlert
					description={t(
						'offsets.notifications.youCantSelectMoreThan4Projects'
					)}
				/>
			)}
		</Box>
	);
};

export default AdditionalitiesOffsetSummaryCart;
